// extracted by mini-css-extract-plugin
export default {"typeContent":"SuburbTrailerTypeLandingPage_typeContent__mNbad"};